import React from "react";
import { useTranslation } from "react-i18next";

export default function HaProfileConfig() {
  const { t } = useTranslation("help");

  return (
    <div className="profile-config-container">
      <div className="profile-config-title">
        <h3>{t("HaProfileConfig.title", "Profile Config (AI Model Attack Surface)")}</h3>
      </div>

      <pre className="code-block">
        <code>{`{
    "profile_type": "ai_model_attack_surface",
    "test_file_paths": {
        "dos": [],
        "llm": [
            {
                "file_name": "",
                "file_path": "",
                "file_creation_method": ""
            }
        ],
        "mcp": [],
        "rto": [],
        "docs": [],
        "frame": [],
        "prompts": [],
        "custom_decision_tree": [],
        "rc_prompts": []
    },
    "llm_api_mis_use_abuse": {
        "sub": {
            "key_token_abuse_llm": {
                "enabled": false
            },
            "invalid_api_attempts_llm": {
                "enabled": false
            },
            "man_in_the_middle_attacks": {
                "enabled": false
            },
            "anomalous_access_patterns_llm": {
                "enabled": false
            }
        },
        "enabled": false
    }
}`}</code>
      </pre>

      <style>{`
        .profile-config-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
        }

        .profile-config-title {
          color: #ffffff;
          font-size: 13px;
          font-weight: 400;
          margin-bottom: 20px;
          text-decoration: underline;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 13px;
          line-height: 1.48;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .profile-config-title {
            font-size: 13px;
            margin-bottom: 18px;
          }

          .code-block {
            font-size: 12px;
            line-height: 1.45;
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
}